import { render, staticRenderFns } from "./historyFeeDetailImportList.vue?vue&type=template&id=0a226140&scoped=true"
import script from "./historyFeeDetailImportList.vue?vue&type=script&lang=js"
export * from "./historyFeeDetailImportList.vue?vue&type=script&lang=js"
import style0 from "./historyFeeDetailImportList.vue?vue&type=style&index=0&id=0a226140&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a226140",
  null
  
)

export default component.exports